interface SectionHeading {
  readMore: string;
  readLess: string;
}
interface Faq {
  question: string;
  answer: string;
}

interface GetInTouch {
  buttonText: string;
  footerText: string;
}

interface FaqSectionData {
  faqs: Faq[];
  getInTouch: GetInTouch;
  imageSrc: string;
  imageAlt: string;
  title: string;
  backgroundImage: string;
}

interface CourseDetailItem {
  title: string;
  data: string;
}

interface CourseDetails {
  title: string;
  items: CourseDetailItem[];
}

interface CourseRequirement {
  title: string;
  data: string;
}

interface ScholarshipInfo {
  title: string;
  description: string;
  items: string[];
}

interface CourseDetailSection {
  courseDetails: CourseDetails;
  courseRequirements: CourseRequirement[];
  otherRequirements: string[];
  scholarshipInfo: ScholarshipInfo;
  buttonText: string;
  bordertitle: string;
  borderparagraph: string;
  otherRequirementsTitle: string;
  scholarshipInfoSectionTitle: string;
  courseRequirementstitle: string;
  backgroundImage: string;
}

export interface CourseInfo {
  title: string;
  icon: string;
  value: string;
}

interface CourseAttributeSection {
  didYouKnow: string;
  title: string;
  paragraph: string;
  image: string;
  alt: string;
  vectorImage: string;
  courseAttributesTitle: string;
  courseAttributes: CourseInfo[];
}

interface University {
  name: string;
  address: string;
}

interface UniversityLocationSection {
  title: string;
  universities: University[];
}

interface RatingDetails {
  name: string;
  value: number;
  stock: number;
}

interface MainRating {
  title: string;
  value: number;
  buttonText: string;
}
interface RankingInfoSection {
  ratingDetails: RatingDetails[];
  mainRating: MainRating;
  title: string;
  paragraph: string;
  bgImage: string;
}

export interface HelpModalContent {
  header: string;
  description: string;
  fields: {
    firstName: string;
    lastName: string;
    email: string;
    contactNumber: string;
    subjectLabel: string;
    messageLabel: string;
    messagePlaceholder: string;
  };
  buttons: {
    cancel: string;
    send: string;
  };
  images: {
    desktop: string;
    mobile: string;
  };
}

interface GradientHeading {
  title: string;
  subtitle: string;
}

interface CourseHeadingContent {
  location: string;
  ranking: number;
  websiteLink: string;
  buttonLabels: {
    requestDetails: string;
    addSuggestions: string;
  };
  ratingText: string;
  rankingText: string;
  officialWebsite: string;
  username: string;
}

export const gradientHeadingData: GradientHeading = {
  title: "Master of Educational Studies (MA)",
  subtitle: "At Yale University",
};

export const courseHeadingContentData: CourseHeadingContent = {
  username: "Jerry",
  location: "New Haven, CT 06520, USA",
  ranking: 347,
  websiteLink: "https://example.com",
  buttonLabels: {
    requestDetails: "Request more details",
    addSuggestions: "Add your suggestions",
  },
  ratingText: "Times Rating",
  rankingText: "Times Ranking",
  officialWebsite: "Official university website",
};

export const rankingInfoData: RankingInfoSection = {
  bgImage: "/images/course-detail/bg-university-ranking.png",
  title: "University rating",
  paragraph: "This rating is an overall score of Times Course Finder",
  mainRating: {
    title: "Times Ranking",
    value: 327,
    buttonText: " Based on overall",
  },
  ratingDetails: [
    {
      name: "QS World university ranking",
      value: 75,
      stock: 208,
    },
    {
      name: "Times higher education world ranking",
      value: 60,
      stock: 208,
    },
    {
      name: "US news world ranking",
      value: 50,
      stock: 208,
    },
    {
      name: "US news national ranking",
      value: 50,
      stock: 208,
    },
    {
      name: "Shanghai ranking",
      value: 85,
      stock: 208,
    },
    {
      name: "TCF ranking",
      value: 40,
      stock: 208,
    },
  ],
};

export const courseDetailData: CourseDetailSection = {
  otherRequirementsTitle: "Other Requirements",
  scholarshipInfoSectionTitle: "In this guide you will find:",
  courseRequirementstitle: "Course requirements",
  backgroundImage: "/images/course-detail/bg-course-requirements.png",
  courseDetails: {
    title: "Course details",
    items: [
      {
        title: "Application deadline",
        data: "16 Sep 2024",
      },
      {
        title: "IELTS",
        data: "7+",
      },
      {
        title: "PTE",
        data: "65",
      },
      {
        title: "TOEFL",
        data: "100+",
      },
    ],
  },
  courseRequirements: [
    {
      title: "A level",
      data: "C, C",
    },
    {
      title: "IELTS",
      data: "7+",
    },
    {
      title: "UCAS Tariff",
      data: "64",
    },
  ],
  otherRequirements: [
    "600 on the paper-based TOEFL; 250 on the computer-based TOEFL",
    "Pearson Test of English (PTE): The minimum acceptable score is 70.",
  ],
  scholarshipInfo: {
    title: "Scholarship guide",
    description:
      "One of the important factors when considering a master's degree is the cost of study. Luckily, there are many options available to help students fund their master's programme. Download your copy of the Scholarship Guide to find out which scholarships from around the world could be available to you, and how to apply for them.",
    items: [
      "Where to look for scholarship opportunities",
      "How to apply to scholarships relevant to you",
      "A list of available scholarships around the world",
      "A scholarship application checklist",
    ],
  },
  buttonText: "Download Scholarship Guide",
  bordertitle: "Course requirements and scholarships guide",
  borderparagraph:
    "Being the third-oldest higher education institute in the United States, Yale University (YU) was established in 1701 as the Collegiate School in New Haven, Connecticut. The school was renamed Yale College in 1718 to honor the school's largest benefactor, Elihu Yale. YU was awarded its first doctorate in 1861 and organized as a university in 1887. It has recognition from the New England Commission of Higher Education since 1929 and accreditation from Association to Advance Collegiate Schools of Business, American Bar Association, and Council of the Section of Legal Education and Admissions to the Bar. It classifies as 'R1: Doctoral Universities – Very high research activity'. Yale University is deemed one of the top-ranking universities for international students in the United States.",
};

export const faqData: FaqSectionData = {
  faqs: [
    {
      question: "How to apply for a course?",
      answer: "Lorem ipsum dolor sit amet...",
    },
    {
      question: "How to apply for a course?",
      answer: "Lorem ipsum dolor sit amet...",
    },
    {
      question: "What are the course fees?",
      answer:
        "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
    },
    {
      question: "How to apply for a course?",
      answer: "Lorem ipsum dolor sit amet...",
    },
    {
      question: "What are the course fees?",
      answer:
        "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
    },

    {
      question: "What are the course fees?",
      answer:
        "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
    },
  ],
  getInTouch: {
    buttonText: "Get in touch",
    footerText: "Still need help? Chat with us",
  },
  imageSrc: "/images/course-detail/faqs.png",
  imageAlt: "Mascot Image",
  title: "FAQs",
  backgroundImage: "/images/course-detail/bg-course-requirements.png",
};

export const courseAttributesData: CourseAttributeSection = {
  title: "About the Course",
  vectorImage: "/images/course-detail/vector-arrow.png",
  paragraph:
    "Being the third-oldest higher education institute in the United States, Yale University (YU) was established in 1701 as the Collegiate School in New Haven, Connecticut. The school was renamed Yale College in 1718 to honor the school's largest benefactor, Elihu Yale. YU was awarded its first doctorate in 1861 and organized as a university in 1887. It has recognition from the New England Commission of Higher Education since 1929 and accreditation from Association to Advance Collegiate Schools of Business, American Bar Association, and Council of the Section of Legal Education and Admissions to the Bar. It classifies as 'R1: Doctoral Universities – Very high research activity'. Yale University is deemed one of the top-ranking universities for international students in the United States.",
  didYouKnow:
    "Taking the right course can boost your career prospects by up to 60%, according to global employment trends. Whether you're looking to upskill, switch careers, or dive into a new field, choosing the right course can make all the difference in achieving your goals!",
  courseAttributesTitle: "Course Information",
  image: "/images/course-detail/did-you-know.png",
  alt: "Did You Know Illustration",
  courseAttributes: [
    {
      title: "Discipline",
      icon: "Discipline",
      value: "Architecture",
    },
    {
      title: "Degree Level",
      icon: "Degree",
      value: "Bachelors",
    },
    {
      title: "Campus",
      icon: "Campus",
      value: "Onsite",
    },
    {
      title: "Study Mode",
      icon: "StudyMode",
      value: "Full time",
    },
    {
      title: "Duration",
      icon: "Duration",
      value: "03 years",
    },
    {
      title: "Intakes",
      icon: "Intake",
      value: "September, January",
    },
  ],
};

export const universityLocationData: UniversityLocationSection = {
  title: "Location",
  universities: [
    {
      name: "Yale University, New Haven",
      address: "New Haven, CT 06520, United States",
    },
    {
      name: "Yale University, New Haven",
      address: "1 Long Wharf Dr, New Haven, CT 06511, United States",
    },
    {
      name: "Yale University, New Haven",
      address: "1 Long Wharf Dr, New Haven, CT 06511, United States",
    },
  ],
};

export const helpModalContent: HelpModalContent = {
  header: `Hello, how can we help you?`,
  description:
    "Looking for more information? Fill out the form below, and our team will get in touch with you shortly to provide detailed guidance on courses, universities, or scholarships. We're here to help you make informed decisions and find the right path for your educational journey.",
  fields: {
    firstName: "First name",
    lastName: "Last name",
    email: "Email address",
    contactNumber: "Contact number",
    subjectLabel: "Subject",
    messageLabel:
      "Let us know your questions, and our team will assist you promptly with the information you need.",
    messagePlaceholder: "There is...",
  },
  buttons: {
    cancel: "Cancel",
    send: "Send",
  },
  images: {
    desktop: "/images/course-detail/help-modal.png",
    mobile: "/images/course-detail/help-modal-mobile.png",
  },
};
export const sectionHeadingData: SectionHeading = {
  readMore: "Read More",
  readLess: "Read Less",
};

export interface CourseRecommendation {
  type: string;
  name: string;
  institute: string;
   duration: string | null 
  fee: number | null;
  url: string;
}

export interface ScholarshipRecommendation {
  type: string;
  name: string;
  university: string;
  url:string;
}

export interface ScholarshipEmailPayload {
  student_name: string;
  student_email: string;
  consultant_email: string;
  recommendations: ScholarshipRecommendation[];
}
export interface RecommendationEmailPayload {
  student_name: string;
  student_email: string;
  consultant_email: string;
  recommendations: CourseRecommendation[];
}

export interface ShortCourseRecommendation {
  type: string;
  name: string;
  university: string;
  duration: string | null;
  fee: number | null;
  url: string;
}

export interface ShortCourseEmailPayload  {
  student_name: string;
  student_email: string;
  consultant_email: string;
  recommendations: ShortCourseRecommendation[];
}
